/*
 *  `global` module
 *  ===============
 *
 *  The runtime global instance settings.
 */
export default {
	user: {},
	game: {
		modes: []
	},
	mode: {},
	dict: {},
	skills: [],
	superpowers: [],
	gamifications: [],
	statuses: {
		modes: {},
		gamification: {},
		superpower: {},
		round: {}
	},
	constants: {
		round: {},
		superpower: {}
	},
	round: {},
	ranking: {},
	// Tipo di autenticazione: 'facebook' o 'email'
	authType: null,
	// Flag per tracciare se c'è un gioco in corso (scena Game attiva/in pausa)
	gameInProgress: false,
	// ID del round completato per la sfida (usato tra scene GameOver e ChallengeSelection)
	challengeRoundId: null
};
